import dashboard from './dashboard';
import projects from './projects';
import version from './version';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, projects, version]
};

export default menuItems;
